<template>
  <K2Row align="center">
    <K2Text v-if="label" class="me-2">{{ label }}</K2Text>
    <el-select v-model="selected" placeholder="Select" :style="style" @change="handleClick">
      <el-option v-for="item in selectList" :key="item" :label="item.label" :value="item"> </el-option>
    </el-select>
  </K2Row>
</template>

<script>
import uiVariable from '../../config/uiVariable'
import K2Row from '../k2Row/k2Row'
import K2Text from '../k2Text/k2Text'

export default {
  name: 'K2Select',
  components: { K2Text, K2Row },
  props: ['selectList', 'onChange', 'label', 'style'],
  data: function () {
    return {
      uiVariable: uiVariable,
      selected: '',
    }
  },
  methods: {
    handleClick() {
      this.$emit('onChange', this.selected)
    },
  },
}
</script>
